 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_FRONTISPIECE from '@/components/xhtml/01_Frontispiece'
 import XHTML02_TITLE_PAGE from '@/components/xhtml/02_Title_Page'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTML04_DEDICATION from '@/components/xhtml/04_Dedication'
 import XHTML05_CONTENTS from '@/components/xhtml/05_CONTENTS'
 import XHTML06_ACKNOWLEDGMENTS from '@/components/xhtml/06_Acknowledgments'
 import XHTML07_EDITORIAL_PRACTICES from '@/components/xhtml/07_Editorial_Practices'
 import XHTML08_DRAMATIS_PERSONAE from '@/components/xhtml/08_Dramatis_Personae'
 import XHTML09_TIMELINE from '@/components/xhtml/09_Timeline'
 import XHTML10_MAP_OF_TEXAS from '@/components/xhtml/10_Map_of_Texas'
 import XHTML11_INTRODUCTION__LUCY__HERSELF__HER from '@/components/xhtml/11_Introduction__Lucy__Herself__Her'
 import XHTML12_CHAPTER_1__JANUARY_1863 from '@/components/xhtml/12_Chapter_1__January_1863'
 import XHTML13_CHAPTER_2__FEBRUARY_1863 from '@/components/xhtml/13_Chapter_2__February_1863'
 import XHTML14_CHAPTER_3__MARCH_1863 from '@/components/xhtml/14_Chapter_3__March_1863'
 import XHTML15_CHAPTER_4__APRIL_MAY_1863 from '@/components/xhtml/15_Chapter_4__April_May_1863'
 import XHTML16_CHAPTER_5__JUNE_JULY_1863 from '@/components/xhtml/16_Chapter_5__June_July_1863'
 import XHTML17_CHAPTER_6__AUGUST_SEPTEMBER_1863 from '@/components/xhtml/17_Chapter_6__August_September_1863'
 import XHTML18_CHAPTER_7__OCTOBER_DECEMBER_1863 from '@/components/xhtml/18_Chapter_7__October_December_1863'
 import XHTML19_CHAPTER_8__JANUARY_FEBRUARY_1864 from '@/components/xhtml/19_Chapter_8__January_February_1864'
 import XHTML20_CHAPTER_9__MARCH_APRIL_1864 from '@/components/xhtml/20_Chapter_9__March_April_1864'
 import XHTML21_CHAPTER_10__MAY_JUNE_1864 from '@/components/xhtml/21_Chapter_10__May_June_1864'
 import XHTML22_CHAPTER_11__JULY_SEPTEMBER_1864 from '@/components/xhtml/22_Chapter_11__July_September_1864'
 import XHTML23_CHAPTER_12__OCTOBER_DECEMBER_186 from '@/components/xhtml/23_Chapter_12__October_December_186'
 import XHTML24_CHAPTER_13__JANUARY_1865 from '@/components/xhtml/24_Chapter_13__January_1865'
 import XHTML25_CHAPTER_14__FEBRUARY_MARCH_1865 from '@/components/xhtml/25_Chapter_14__February_March_1865'
 import XHTML26_CHAPTER_15__APRIL_1_16__1865 from '@/components/xhtml/26_Chapter_15__April_1_16__1865'
 import XHTML27_CHAPTER_16__APRIL_17_MAY_4__1865 from '@/components/xhtml/27_Chapter_16__April_17_May_4__1865'
 import XHTML28_LUCY__HER_WORLD_AFTER_TEXAS from '@/components/xhtml/28_Lucy__Her_World_after_Texas'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML29_BIBLIOGRAPHY from '@/components/xhtml/29_Bibliography'
 import XHTML30_INDEX from '@/components/xhtml/30_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/05_CONTENTS",
 			"name" : "xhtml/05_CONTENTS",
 			"component" : XHTML05_CONTENTS
 		},
 		{
 			"path" : "/xhtml/06_Acknowledgments",
 			"name" : "xhtml/06_Acknowledgments",
 			"component" : XHTML06_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/07_Editorial_Practices",
 			"name" : "xhtml/07_Editorial_Practices",
 			"component" : XHTML07_EDITORIAL_PRACTICES
 		},
 		{
 			"path" : "/xhtml/08_Dramatis_Personae",
 			"name" : "xhtml/08_Dramatis_Personae",
 			"component" : XHTML08_DRAMATIS_PERSONAE
 		},
 		{
 			"path" : "/xhtml/09_Timeline",
 			"name" : "xhtml/09_Timeline",
 			"component" : XHTML09_TIMELINE
 		},
 		{
 			"path" : "/xhtml/10_Map_of_Texas",
 			"name" : "xhtml/10_Map_of_Texas",
 			"component" : XHTML10_MAP_OF_TEXAS
 		},
 		{
 			"path" : "/xhtml/11_Introduction__Lucy__Herself__Her",
 			"name" : "xhtml/11_Introduction__Lucy__Herself__Her",
 			"component" : XHTML11_INTRODUCTION__LUCY__HERSELF__HER
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js